import { NgModule } from "@angular/core";
import { NgxPaginationModule } from "ngx-pagination";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadingModule } from "ngx-loading";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxPermissionsModule } from "ngx-permissions";
import { RouterModule } from "@angular/router";

import { routes } from "./whatsnew.routing";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { PipesModule } from "../pipes/pipes.module";
import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { WhatsNewService } from "./services/whatsnew.service";
import { WhatsNewComponent } from "./whatsnew/whatsnew.component";
import { WhatsNewFormComponent } from "./whatsnew/whatsnew/whatsnew-form.component";
import { SharedModule } from "../../modules/shared.module";
import {
  MatAutocompleteModule,
  MatDialogModule,
  MatRadioModule,
} from "@angular/material";
import { OverlayPanelModule, TooltipModule } from "primeng/primeng";
import { AppColoredLabelModule } from "../../components/app-colored-label/app-colored-label.module";
import { UnityChartModule } from "../../components/unity-chart/unity-chart.module";
import { AppSpinnerDivModule } from "../../components/app-spinner-div/app-spinner-div.module";
import { LocalDatePipe } from "../pipes/local-date.pipe";
import { DisplayFieldPipe } from "../pipes/displayField.pipe";
import { CurrencyPipe } from "@angular/common";
import { TableExtensionService } from "./table-extension.service";

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    NgxPaginationModule,
    NgxDatatableModule,
    LoadingModule,
    NgxPermissionsModule.forChild(),
    NgbModule,
    RouterModule.forChild(routes),
    PipesModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    SharedModule,
    MatDialogModule,
    TooltipModule,
    MatAutocompleteModule,
    OverlayPanelModule,
    AppColoredLabelModule,
    MatRadioModule,
    UnityChartModule,
    AppSpinnerDivModule,
  ],
  providers: [
    WhatsNewService,
    LocalDatePipe,
    DisplayFieldPipe,
    CurrencyPipe,
    TableExtensionService,
  ],
  declarations: [
    WhatsNewComponent,
    WhatsNewFormComponent,

  ],
  entryComponents: [WhatsNewComponent, WhatsNewFormComponent],
})
export class WhatsNewModule {}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/whatsnew/whatsnew.module.ts